var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreinamentoSecretarial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 58.4375C76.2438 58.4375 63.5938 61.6 63.5938 67.925V96.25C63.5938 98.175 65.1063 99.6875 67.0312 99.6875H73.9062V122.031C73.9062 126.775 77.7562 130.625 82.5 130.625C87.2438 130.625 91.0938 126.775 91.0938 122.031V99.6875H97.9688C99.8938 99.6875 101.406 98.175 101.406 96.25V67.925C101.406 61.6688 88.7562 58.4375 82.5 58.4375ZM82.5 13.75C44.4812 13.75 13.75 44.4812 13.75 82.5C13.75 120.519 44.4812 151.25 82.5 151.25C120.519 151.25 151.25 120.45 151.25 82.5C151.25 44.55 120.45 13.75 82.5 13.75ZM82.5 137.5C52.1125 137.5 27.5 112.887 27.5 82.5C27.5 52.1125 52.1125 27.5 82.5 27.5C112.887 27.5 137.5 52.1125 137.5 82.5C137.5 112.887 112.887 137.5 82.5 137.5Z",
    fill: "#0F4C81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 55C88.1954 55 92.8125 50.3829 92.8125 44.6875C92.8125 38.9921 88.1954 34.375 82.5 34.375C76.8046 34.375 72.1875 38.9921 72.1875 44.6875C72.1875 50.3829 76.8046 55 82.5 55Z",
    fill: "#0F4C81"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreinamentoSecretarial);
export default __webpack_public_path__ + "static/media/TreinamentoSecretarial.3ff8734d4e853cbeef13f27fa09ad653.svg";
export { ForwardRef as ReactComponent };